import React, { createContext, useEffect, useMemo, useReducer } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import { useParams } from "react-router-dom";
import useError from "../../hooks/useError";
import SessionOut from "../../views/sessions/SessionOut";

const initialValue = {
    details: [],
    updateNotifier:null
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SELLER_DATA': {
            return {
                ...state,
                seller_detail: action.payload,
            }
        }
        case 'UPDATE_STATUS': {
            
            let newData = state?.seller_detail?.details?.products ? state?.seller_detail?.details?.products.map((pro) =>
                action?.payload?.data?.id === pro?.id ? action?.payload?.data : pro
            ) : [];

            if(!newData){
                return {
                    updateNotifier: new Date().getTime(),
                    ...state
                };
            }

            let newState = {
                details: {...state?.seller_detail?.details, products: newData}
            }
            return {
                ...state,
                seller_detail: newState,
            }
        }

        case 'REMOVE_FEATURED': {

            let newData = state.seller_detail.details.products.map((pro) =>
                action.payload.data.id === pro.id ? action.payload.data : pro
            );
            let newState = {
                details: {...state.seller_detail.details, products: newData}
            }
            return {
                ...state,
                seller_detail: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const SellerDetailContext = createContext({
    seller_detail: initialValue,
    updateNotifier: null,
    getSellerDetail: () => {},
    changeProductStatus: () => {},
    make_featured: () => {},
    remove_featured: () => {},
    updateSeller: () => {},
    updateSellerLatLng: () => {},
    changeProductDelivery: () => {},
})

export const SellerDetailProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { id } = useParams();
    const { setError } = useError();


    const getSellerDetail = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/get_seller_details/'+id, options);
            
            dispatch({
                type: 'LOAD_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e?.response?.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e?.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const updateSeller = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            return await axios.post('/api/sellers/edit_seller', data, options);
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const updateSellerLatLng = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }
            setError({title: "Success", message: "Seller updated successfully", status: 400})

            return await axios.post('/api/sellers/edit_seller_latlng', data, options);
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }



    const changeProductDelivery = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_delivery/${product_id}/${status}`, options);

            dispatch({
                type: 'UPDATE_STATUS',
                payload: res.data
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const changeProductStatus = async (product_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_status/${product_id}/${status}`, options);

            dispatch({
                type: 'UPDATE_STATUS',
                payload: res.data
            })

        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e?.response?.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e?.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const make_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/make_featured/${product_id}`, options);

            dispatch({
                type: 'MAKE_FEATURED',
                payload: res.data
            })


        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const remove_featured = async (product_id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/remove_featured/${product_id}`, options);
            dispatch({
                type: 'REMOVE_FEATURED',
                payload: res.data
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }








    useEffect(() => {
        getSellerDetail(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.status === 401){
        return <SessionOut />
    }

    if(state.seller_detail === undefined) {
        return <MatxLoading />
    }

    return (
        <SellerDetailContext.Provider
            value={{
                seller_detail: state.seller_detail,
                updateNotifier: state.updateNotifier,
                getSellerDetail,
                changeProductStatus,
                make_featured,
                remove_featured,
                updateSeller,
                updateSellerLatLng,
                changeProductDelivery,
            }}
        >
            {children}
        </SellerDetailContext.Provider>
    )
}

export default SellerDetailContext
